import { createStore, applyMiddleware } from 'redux'
import reducer from './reducer'
import { API } from '../config/API';
import Cookies from 'js-cookie';
// import Cookies from 'js-cookie';

const api = store => next => async action => {
  let token = Cookies.get('token_fkub')

  if (action.type === 'FETCH_DATA_REFERENSI') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {
      let query = `limit=${100}&skip=${0}`
      if (action.payload) {
        if (action.payload.category_upload) query += `&category_upload=${action.payload.category_upload}`
        if (action.payload.keyword) query += `&title=${action.payload.keyword}`
      }

      let { data } = await API.get(`/api/v1/book/list?${query}`, { headers: { token: `Bearer ${token}` } })

      next({
        type: 'FETCH_DATA_REFERENSI_SUCCESS',
        payload: {
          dataBuku: data.data.books
        }
      })
    } catch (err) {
      // console.log("FETCH_DATA_BOOKS", { err })
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_NEWS') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {
      let query = ''

      if (action.payload.keyword) query = `?keyword=${action.payload.keyword}`

      let { data } = await API.get(`/api/v1/news/list${query}`)

      next({
        type: 'FETCH_DATA_NEWS_SUCCESS',
        payload: {
          dataNews: data.data.news,
        }
      })
    } catch (err) {
      // console.log("FETCH_DATA_NEWS", { err })
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_ARTIKEL_ID') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {let { data } = await API.get(`/api/v2/news/${action.payload.id}`)

      next({
        type: 'FETCH_DATA_ARTIKEL_ID_SUCCESS',
        payload: {
          dataArtikelId: data.data.newsAddVisitor,
        }
      })
    } catch (err) {
      // console.log("FETCH_DATA_NEWS", { err })
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_ARTIKEL_SLUG') {
    const slug = action.payload?.slug;
    const lang = action.payload?.lang || 'id';
  
    if (!slug) {
      console.warn('Slug tidak tersedia di action.payload');
      return next({
        type: 'FETCH_DATA_ERROR',
        payload: 'Slug tidak tersedia'
      });
    }
  
    next({ type: 'FETCH_DATA_LOADING' });
  
    try {
      const { data } = await API.get(`/api/v2/news/slug/${slug}?lang=${lang}`);
      next({
        type: 'FETCH_DATA_ARTIKEL_ID_SUCCESS',
        payload: {
          dataArtikelId: data?.data?.news || {},
        }
      });
    } catch (err) {
      console.error("Error FETCH_DATA_ARTIKEL_SLUG:", err.response?.data || err.message);
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      });
    }
  }
  
  else if (action.type === 'FETCH_DATA_BERITA_PUSAT_ID') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {let { data } = await API.get(`/api/v2/news/${action.payload.id}`)

      next({
        type: 'FETCH_DATA_BERITA_PUSAT_ID_SUCCESS',
        payload: {
          dataBeritaPusatId: data?.data?.newsAddVisitor || data?.data?.news || data?.data || {},
        }
      })
    } catch (err) {
      // console.log("FETCH_DATA_NEWS", { err })
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_BERITA_PUSAT_SLUG') {
    const slug = action.payload?.slug;
    const lang = action.payload?.lang || 'id'; // fallback bahasa default
  
    if (!slug) {
      console.warn('Slug tidak tersedia di action.payload');
      return next({
        type: 'FETCH_DATA_ERROR',
        payload: 'Slug tidak tersedia'
      });
    }
  
    next({ type: 'FETCH_DATA_LOADING' });
    // console.log("Request ke API dengan slug:", slug, "lang:", lang);
  
    try {
      const { data } = await API.get(`/api/v2/news/slug/${slug}?lang=${lang}`);
      // console.log("Response API:", data);
  
      next({
        type: 'FETCH_DATA_BERITA_PUSAT_ID_SUCCESS',
        payload: {
          dataBeritaPusatId: data?.data?.news || {},
        }
      });
    } catch (err) {
      console.error("Error FETCH_DATA_BERITA_PUSAT_SLUG:", err.response?.data || err.message);
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      });
    }
  }
  
  else if (action.type === 'FETCH_DATA_BERITA_DAERAH_ID') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {let { data } = await API.get(`/api/v2/news/${action.payload.id}`)

      next({
        type: 'FETCH_DATA_BERITA_DAERAH_ID_SUCCESS',
        payload: {
          dataBeritaDaerahId: data.data.newsAddVisitor,
        }
      })
    } catch (err) {
      // console.log("FETCH_DATA_NEWS", { err })
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_BERITA_DAERAH_SLUG') {
    const slug = action.payload?.slug;
    const lang = action.payload?.lang || 'id';
  
    if (!slug) {
      console.warn('Slug tidak tersedia di action.payload');
      return next({
        type: 'FETCH_DATA_ERROR',
        payload: 'Slug tidak tersedia'
      });
    }
  
    next({ type: 'FETCH_DATA_LOADING' });
  
    try {
      const { data } = await API.get(`/api/v2/news/slug/${slug}?lang=${lang}`);
      next({
        type: 'FETCH_DATA_BERITA_DAERAH_ID_SUCCESS',
        payload: {
          dataBeritaDaerahId: data?.data?.news || {},
        }
      });
    } catch (err) {
      console.error("Error FETCH_DATA_BERITA_DAERAH_SLUG:", err.response?.data || err.message);
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      });
    }
  }
  
  else if (action.type === 'FETCH_DATA_OPINI_ID') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {let { data } = await API.get(`/api/v2/news/${action.payload.id}`)

      next({
        type: 'FETCH_DATA_OPINI_ID_SUCCESS',
        payload: {
          dataOpiniId: data.data.newsAddVisitor,
        }
      })
    } catch (err) {
      // console.log("FETCH_DATA_NEWS", { err })
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_OPINI_SLUG') {
    const slug = action.payload?.slug;
    const lang = action.payload?.lang || 'id';
  
    if (!slug) return next({ type: 'FETCH_DATA_ERROR', payload: 'Slug tidak tersedia' });
  
    next({ type: 'FETCH_DATA_LOADING' });
  
    try {
      const { data } = await API.get(`/api/v2/news/slug/${slug}?lang=${lang}`);
      next({
        type: 'FETCH_DATA_OPINI_ID_SUCCESS',
        payload: { dataOpiniId: data?.data?.news || {} }
      });
    } catch (err) {
      console.error("Error FETCH_DATA_OPINI_SLUG:", err.response?.data || err.message);
      next({ type: 'FETCH_DATA_ERROR', payload: err });
    }
  }
  else if (action.type === 'FETCH_DATA_ARTIKEL_POPULER') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {let { data } = await API.get(`/api/v2/news/${action.payload.category}/populer`)

      next({
        type: 'FETCH_DATA_ARTIKEL_POPULER_SUCCESS',
        payload: {
          dataArtikelPopuler: data.data.news,
        }
      })
    } catch (err) {
      // console.log("FETCH_DATA_NEWS", { err })
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_BERITA_PUSAT_POPULER') {
    next({ type: 'FETCH_DATA_LOADING' });
  
    try {
      let { data } = await API.get(`/api/v2/news/${action.payload.category}/populer`);
      next({
        type: 'FETCH_DATA_BERITA_PUSAT_POPULER_SUCCESS',
        payload: {
          dataBeritaPusatPopuler: data.data.news, 
        },
      });
    } catch (error) {
      //console.log('Error fetchDataBeritaPusatPopuler:', error);
    }
  }
  else if (action.type === 'FETCH_DATA_BERITA_DAERAH_POPULER') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {let { data } = await API.get(`/api/v2/news/${action.payload.category}/populer`)

      next({
        type: 'FETCH_DATA_BERITA_DAERAH_POPULER_SUCCESS',
        payload: {
          dataBeritaDaerahPopuler: data.data.news,
        }
      })
    } catch (err) {
      // console.log("FETCH_DATA_NEWS", { err })
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_OPINI_POPULER') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {let { data } = await API.get(`/api/v2/news/${action.payload.category}/populer`)

      next({
        type: 'FETCH_DATA_OPINI_POPULER_SUCCESS',
        payload: {
          dataOpiniPopuler: data.data.news,
        }
      })
    } catch (err) {
      // console.log("FETCH_DATA_NEWS", { err })
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_ARTIKEL') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {
      let query = `?skip=${action.payload.skip}&limit=${action.payload.limit}&category=${action.payload.category}&status=approve`
      let { data } = await API.get(`/api/v2/news${query}`)

      next({
        type: 'FETCH_DATA_ARTIKEL_SUCCESS',
        payload: {
          dataArtikel: data.data.news,
          totalDataArtikel: data.data.total
        }
      })
    } catch (err) {
      // console.log("FETCH_DATA_NEWS", { err })
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_BERITA_PUSAT') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {
      let query = `?skip=${action.payload.skip}&limit=${action.payload.limit}&category=${action.payload.category}&status=approve`
      let { data } = await API.get(`/api/v2/news${query}`)

      next({
        type: 'FETCH_DATA_BERITA_PUSAT_SUCCESS',
        payload: {
          dataBeritaPusat: data.data.news,
          totalDataBeritaPusat: data.data.total
        }
      })
    } catch (err) {
      console.log("FETCH_DATA_NEWS", { err })
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_BERITA_DAERAH') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {
      let query = `?skip=${action.payload.skip}&limit=${action.payload.limit}&category=${action.payload.category}&status=approve`
      let { data } = await API.get(`/api/v2/news${query}`)

      next({
        type: 'FETCH_DATA_BERITA_DAERAH_SUCCESS',
        payload: {
          dataBeritaDaerah: data.data.news,
          totalDataBeritaDaerah: data.data.total
        }
      })
    } catch (err) {
      // console.log("FETCH_DATA_NEWS", { err })
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_OPINI') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {
      let query = `?skip=${action.payload.skip}&limit=${action.payload.limit}&category=${action.payload.category}&status=approve`
      let { data } = await API.get(`/api/v2/news${query}`)

      next({
        type: 'FETCH_DATA_OPINI_SUCCESS',
        payload: {
          dataOpini: data.data.news,
          totalDataOpini: data.data.total
        }
      })
    } catch (err) {
      // console.log("FETCH_DATA_NEWS", { err })
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_ADMINS') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {
      // let { data } = await API.get(`/api/v1/region/list`, { headers: { token: `Bearer ${token}` } })

      // next({
      //   type: 'FETCH_DATA_ADMINS_SUCCESS',
      //   payload: data.data
      // })
    } catch (err) {
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_REGIONS') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {
      let { data } = await API.get(`/api/v1/region/list`, { headers: { token: `Bearer ${token}` } })

      next({
        type: 'FETCH_DATA_REGIONS_SUCCESS',
        payload: data.data
      })
    } catch (err) {
      // console.log("FETCH_DATA_REGIONS", { err })
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_REGISTRATION') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {
      let { data } = await API.get(`/api/v1/registration?registration_step=${action.payload.registration_step}`, { headers: { token: `Bearer ${token}` } })

      next({
        type: 'FETCH_DATA_REGISTRATION_SUCCESS',
        payload: {
          dataRegistration: data.data || [],
          totalCityRegistration: data.total.totalCity,
          totalProvinceRegistration: data.total.totalProvince,
          totalCentralRegistration: data.total.totalCentral,
          availableCreateNew: data.availableCreateNew,
          regisLatest: data.regisLatest
        }
      })
    } catch (err) {
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_REGULATION') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {
      let query = `skip=${action.payload.skip || 0}`
      query += `&limit=${action.payload.limit || 21}`
      query += `&regulationType=${action.payload.regulationType}`
      query += `&sort=terbaru`
      if (action.payload.regulationTypeCategory) query += `&regulationTypeCategory=${action.payload.regulationTypeCategory}`
      if (action.payload.name) query += `&name=${action.payload.name}`

      let { data } = await API.get(`/api/v1/regulation?${query}`, { headers: { token: `Bearer ${token}` } })

      next({
        type: 'FETCH_DATA_REGULATION_SUCCESS',
        payload: {
          dataRegulation: data.data,
          totalPageRegulation: data.pagination.totalPage
        }
      })
    } catch (err) {
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_QUOTE') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {
      let { data } = await API.get(`/api/v1/quote/list?skip=${action.payload.skip}&limit=${action.payload.limit}&title=${action.payload.name || ''}`, { headers: { token: `Bearer ${token}` } })

      next({
        type: 'FETCH_DATA_QUOTE_SUCCESS',
        payload: {
          dataQuote: data.data.quote,
          totalQuote: data.data.total,
          totalNews: data.data.totalNews
        }
      })
    } catch (err) {
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_LAPORAN') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {
      // let query = `categorize=web`
      let query = `page=1`
      query += `&registration_step=${action.payload.registration_step}`
      query += `&sort=terbaru`

      let { data } = await API.get(`/api/v1/report?${query}`, { headers: { token: `Bearer ${token}` } })

      next({
        type: 'FETCH_DATA_LAPORAN_SUCCESS',
        payload: {
          dataLaporan: data.data || [],
          totalReportCity: data.total.totalCity || 0,
          totalReportProvince: data.total.totalProvince || 0,
          totalReportCentral: data.total.totalCentral || 0
        }
      })
    } catch (err) {
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_RUMAH_IBADAT') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {

      let { data } = await API.get(`/api/v1/rumah-ibadat/list-mobile`, { headers: { token: `Bearer ${token}` } })

      next({
        type: 'FETCH_DATA_RUMAH_IBADAT_SUCCESS',
        payload: {
          dataRumahIbadat: data.data?.data || {},
          dataDuplicateCalon: data.data?.duplicate_calon || [],
          dataDuplicateMasyarakat: data.data?.duplicate_masyarakat || []
        }
      })

    } catch (err) {
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'FETCH_DATA_LIST_FKUB') {
    next({
      type: 'FETCH_DATA_LOADING'
    })

    try {
      let query = `skip=${action.payload.skip}`
      query += `&limit=${action.payload.limit}`
      if (action.payload.keyword) query += `&name=${action.payload.keyword}`
      if (action.payload.tingkat) query += `&tingkat=${action.payload.tingkat}`

      let { data } = await API.get(`/api/v1/registration/list-fkub?${query}`)

      next({
        type: 'FETCH_DATA_LIST_FKUB_SUCCESS',
        payload: {
          dataFKUB: data.data || [],
          totalPageListFKUB: data.pagination.totalPage
        }
      })



    } catch (err) {
      next({
        type: 'FETCH_DATA_ERROR',
        payload: err
      })
    }
  }
  else if (action.type === 'VERIFICATION_TOKEN') {
    try {
      let { data } = await API.get(`/auth/verify`, {
        baseURL: 'https://sso.kemenag.go.id',
        headers: {
          Authorization: `Bearer ${action.payload}`
        }
      })

      next({
        type: 'VERIFICATION_SUCCESS',
        payload: {
          dataVerificationToken: data.data || [],
        }
      })
    } catch (err) {
      // console.log(err)
      next({
        type: 'VERIFICATION_ERROR',
        payload: `message: ${err}, headers: ${err.headers}`
      })
    }
  }

  else {
    next(action)
  }
}

const store = createStore(reducer, applyMiddleware(api))

export default store
